"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorDialogContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ErrorDialogContainer = styled_components_1.default.div `
  display: inline-block;
  border: 2px solid rgb(128, 128, 128);
  border-radius: 3px;

  width: 570px;

  text-align: center;

  margin: 10px 0 10px 0;
`;
//# sourceMappingURL=error-dialog-container.js.map